import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import InvestImpactDetails from "./components/InvestImpactDetails";

export default function InvestmentImpact() {
  return (
    <Layout>
      <NewsHeader>Navigating Impact Investment In Bangladesh</NewsHeader>
      <InvestImpactDetails />
    </Layout>
  );
}
